import {Injectable}       from '@angular/core';
import {NativeDateAdapter} from '@angular/material/core';

@Injectable()
export class UkDateAdapter extends NativeDateAdapter
{
    public override parse(value: unknown): Date | null
    {
        if (typeof value !== 'string') {
            return super.parse(value);
        }

        const input = value.trim();
        if (input === '') {
            return null;
        }

        const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(input);
        if (!match) {
            return super.parse(value);
        }

        const day = Number(match[1]);
        const month = Number(match[2]);
        const year = Number(match[3]);
        const daysInMonth = month >= 1 && month <= 12
            ? new Date(year, month, 0).getDate()
            : 0;

        if (year < 1 || day < 1 || day > daysInMonth) {
            return this.invalid();
        }

        return this.createDate(year, month - 1, day);
    }
}
